<template>
  <div class="merchant-management">
    <el-card class="mb-4" shadow="never">
      <el-form :model="searchForm" inline>
        <el-form-item label="用户昵称">
          <el-input placeholder="请输入用户昵称" v-model="searchForm.nickName"></el-input>
        </el-form-item>
        <el-form-item label="用户账号">
          <el-input placeholder="请输入用户账号" v-model="searchForm.account"></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input placeholder="请输入用户电话" v-model="searchForm.mobile"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="mb-4" shadow="never">
      <div class="toolbar">
        <el-button type="primary" @click="showAddModal">新增</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
        <el-table-column prop="id" label="用户ID" width="80" />
        <el-table-column prop="nickName" label="用户昵称" />
        <el-table-column prop="account" label="用户账号" />
        <el-table-column prop="mobile" label="用户电话" />
        <el-table-column prop="dianshu" label="点数" />
        <el-table-column prop="out_date" label="过期时间" :formatter="dateFormatter" />
        <el-table-column prop="is_disable" label="是否禁用" :formatter="isDisableFormatter" />
        <el-table-column prop="create_time" label="创建时间" :formatter="unixDateFormatter" />
        <el-table-column label="操作" width="180">
          <template #default="{ row }">
            <el-link type="primary" @click="showEditModal(row)">编辑</el-link>
            <el-link type="success" style="margin-left:8px;" @click="showRechargeModal(row)">充值</el-link>
            <el-link type="warning" style="margin-left:8px;" @click="showCopyrightModal(row)">版权</el-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[15, 30, 50]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑对话框（移除了版权配置板块） -->
    <el-dialog :title="isEdit ? '编辑商户' : '新增商户'" v-model="dialogVisible" width="800px" destroy-on-close>
      <el-form :model="form" :rules="rules" ref="formRef" label-width="140px">
        <el-divider content-position="left">基本信息</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户昵称" prop="nickName">
              <el-input v-model="form.nickName" placeholder="请输入用户昵称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户账号" prop="account">
              <el-input v-model="form.account" placeholder="请输入用户账号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户密码" prop="password">
              <el-input type="password" v-model="form.password"
                :placeholder="isEdit ? '不填写则不修改密码' : '请输入密码'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户电话" prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入用户电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="点数" prop="dianshu">
              <el-input v-model="form.dianshu" :disabled="isEdit" placeholder="请输入点数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过期时间" prop="out_date">
              <el-date-picker v-model="form.out_date" type="date" placeholder="选择日期" format="YYYY-MM-DD"
                value-format="YYYY-MM-DD" style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="是否禁用" prop="is_disable">
              <el-radio-group v-model="form.is_disable">
                <el-radio :label="0">正常</el-radio>
                <el-radio :label="1">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">阿里云 OSS 存储配置</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="阿里云ID">
              <el-input v-model="form.aliyun_keyid" placeholder="请输入阿里云 AccessKey ID" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="阿里密钥">
              <el-input v-model="form.aliyun_secret" placeholder="请输入阿里云 AccessKey Secret" show-password />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="存储地域">
              <el-input v-model="form.endpoint" placeholder="例：oss-cn-shanghai.aliyuncs.com" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存储桶">
              <el-input v-model="form.aliyun_bucket" placeholder="请输入Bucket名称" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="允许使用上级OSS">
              <el-switch v-model="form.allow_parent_oss" :active-value="1" :inactive-value="0" active-text="允许"
                inactive-text="禁止" />
              <div class="form-tip">开启后，当自有OSS配置不完整时，将自动使用上级的OSS配置</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">腾讯地图配置</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="地图KEY">
              <el-input v-model="form.tencent_map_key" placeholder="请输入腾讯地图 KEY" />
              <div class="form-tip">在腾讯位置服务控制台获取</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地图SK">
              <el-input v-model="form.tencent_map_sk" placeholder="请输入腾讯地图 SK（可选）" show-password />
              <div class="form-tip">用于签名校验，可不填</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="允许使用上级地图">
              <el-switch v-model="form.allow_parent_map" :active-value="1" :inactive-value="0" active-text="允许"
                inactive-text="禁止" />
              <div class="form-tip">开启后，当自有地图KEY不完整时，将自动使用上级的地图配置</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">AI接口配置</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="AI绘图密钥">
              <el-input v-model="form.ai_draw_key" placeholder="请输入AI绘图/视频接口密钥" show-password />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="允许使用上级AI绘图">
              <el-switch v-model="form.ai_allow_parent_draw" :active-value="1" :inactive-value="0" active-text="允许"
                inactive-text="禁止" />
              <div class="form-tip">开启后，将优先使用上级的AI绘图配置</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="AI服务商">
              <el-select v-model="form.ai_provider" placeholder="请选择AI服务商" style="width: 100%"
                @change="onProviderChange">
                <el-option label="DeepSeek" value="deepseek" />
                <el-option label="通义千问" value="tongyi" />
                <el-option label="自定义" value="custom" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="AI接口地址">
              <el-input v-model="form.ai_api_url" placeholder="请输入API接口地址" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="AI模型名称">
              <el-input v-model="form.ai_model" placeholder="请输入模型名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="AI密钥">
              <el-input v-model="form.ai_api_key" placeholder="请输入API密钥" show-password />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最大令牌数">
              <el-input-number v-model="form.ai_max_tokens" :min="1" :max="32000" :step="512" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="温度参数">
              <el-slider v-model="form.ai_temperature" :min="0" :max="2" :step="0.01" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="允许使用上级AI">
              <el-switch v-model="form.ai_allow_parent" :active-value="1" :inactive-value="0" active-text="允许"
                inactive-text="禁止" />
              <div class="form-tip">开启后，将优先使用上级的AI对话配置</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>

    <!-- 充值弹窗 -->
    <el-dialog title="充值" v-model="dialogRechargeVisible" width="400px">
      <div style="color: red; font-size: 12px; font-weight: bold; margin-bottom: 10px; margin-left: 52px;">
        充值成功后，无法撤回，请慎重充值！
      </div>
      <el-form :model="rechargeForm" :rules="rechargeRules" ref="rechargeFormRef" label-width="100px">
        <el-form-item label="类型" prop="type">
          <el-select v-model="rechargeForm.type" placeholder="请选择类型">
            <el-option label="点数" value="dianshu"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="amount">
          <el-input-number v-model="rechargeForm.amount" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogRechargeVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRecharge" :loading="rechargeSubmitting">充值</el-button>
      </template>
    </el-dialog>

    <!-- 商户独立版权管理弹窗 -->
    <el-dialog title="商户版权配置" v-model="dialogCopyrightVisible" width="900px" destroy-on-close>
      <div class="copyright-config-panel">
        <div class="copyright-tip">
          <el-alert title="温馨提示" type="info" :closable="false">
            当版权类型选择"自定义版权"时，下方配置才会生效。选择"默认版权"将继承代理端的版权配置，"关闭版权"则不显示版权信息。<br>
            切换版权类型不会清空已配置的自定义版权内容，方便您随时切换。
          </el-alert>
        </div>

        <!-- 版权类型选择 -->
        <el-form label-width="120px" style="margin-top: 20px;">
          <el-form-item label="版权类型">
            <el-radio-group v-model="copyrightForm.copyright_type" @change="onCopyrightTypeChange">
              <el-radio value="default">默认版权（继承代理配置）</el-radio>
              <el-radio value="custom">自定义版权</el-radio>
              <el-radio value="close">关闭版权（不显示）</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <!-- 自定义版权配置区域 - 始终显示，切换类型不会清空数据 -->
        <div class="custom-copyright-section">
          <el-divider content-position="left">自定义版权内容（切换版权类型后配置不会丢失）</el-divider>
          <div class="copyright-list">
            <div v-for="(item, index) in copyrightForm.copyright_mini" :key="index" class="copyright-item-card">
              <div class="copyright-item-header">
                <span class="copyright-index">第 {{ index + 1 }} 条</span>
                <el-button type="danger" @click="removeCopyright(index)" circle size="small">
                  <el-icon>
                    <Delete />
                  </el-icon>
                </el-button>
              </div>

              <!-- 版权图标上传 -->
              <el-form-item label="版权图标">
                <div class="upload-container">
                  <el-input v-model="item.icon" placeholder="请输入版权图标 URL，或点击上传按钮" class="form-input" clearable />
                  <el-button type="success" @click="handleUploadIcon(index)">
                    <el-icon>
                      <Upload />
                    </el-icon> 上传图标
                  </el-button>
                </div>
                <div class="form-tip">建议尺寸：32x32px，支持 PNG/JPG 格式</div>
                <div v-if="item.icon" class="icon-preview">
                  <img :src="item.icon" alt="版权图标预览" class="preview-img" />
                </div>
              </el-form-item>

              <!-- 版权名称 -->
              <el-form-item label="版权名称" required>
                <el-input v-model="item.key" placeholder="请输入版权名称/备案号/联系方式名称" class="form-input" />
                <div class="form-tip">例如：陕ICP备备号、联系客服、添加微信</div>
              </el-form-item>

              <!-- 功能类型 -->
              <el-form-item label="功能类型" required>
                <el-select v-model="item.type" placeholder="请选择功能类型" style="width: 200px"
                  @change="onItemTypeChange(item)">
                  <el-option label="网页跳转" value="webpage" />
                  <el-option label="小程序跳转" value="mini" />
                  <el-option label="拨打电话" value="tel" />
                  <el-option label="联系微信" value="wechat" />
                  <el-option label="联系企微" value="wecom" />
                </el-select>
                <div class="form-tip">
                  <span v-if="item.type === 'webpage'">点击后打开网页链接</span>
                  <span v-if="item.type === 'mini'">点击后跳转到指定小程序</span>
                  <span v-if="item.type === 'tel'">点击后调起拨号盘</span>
                  <span v-if="item.type === 'wechat'">点击后复制微信号并提示添加</span>
                  <span v-if="item.type === 'wecom'">点击后展示企业微信二维码</span>
                </div>
              </el-form-item>

              <!-- 网页跳转 - 链接地址 -->
              <el-form-item v-if="item.type === 'webpage'" label="链接地址" required>
                <el-input v-model="item.value" placeholder="请输入链接地址，如：https://beian.miit.gov.cn" class="form-input" />
              </el-form-item>

              <!-- 小程序跳转 - 配置 -->
              <template v-if="item.type === 'mini'">
                <el-form-item label="小程序AppID" required>
                  <el-input v-model="item.appid" placeholder="请输入小程序的AppID" class="form-input" />
                </el-form-item>
                <el-form-item label="小程序路径" required>
                  <el-input v-model="item.path" placeholder="请输入小程序页面路径" class="form-input" />
                </el-form-item>
              </template>

              <!-- 拨打电话 - 电话号码 -->
              <el-form-item v-if="item.type === 'tel'" label="电话号码" required>
                <el-input v-model="item.value" placeholder="请输入电话号码，如：400-123-4567" class="form-input" />
              </el-form-item>

              <!-- 联系微信 - 配置 -->
              <template v-if="item.type === 'wechat'">
                <el-form-item label="微信号" required>
                  <el-input v-model="item.value" placeholder="请输入微信号" class="form-input" />
                </el-form-item>
                <el-form-item label="微信二维码">
                  <div class="upload-container">
                    <el-input v-model="item.qrcode" placeholder="请输入微信二维码 URL，或点击上传" class="form-input" clearable />
                    <el-button type="success" @click="handleUploadQrcode(index)">
                      <el-icon>
                        <Upload />
                      </el-icon> 上传二维码
                    </el-button>
                  </div>
                  <div v-if="item.qrcode" class="qrcode-preview">
                    <img :src="item.qrcode" alt="微信二维码预览" class="preview-qrcode" />
                  </div>
                </el-form-item>
              </template>

              <!-- 联系企微 - 配置 -->
              <template v-if="item.type === 'wecom'">
                <el-form-item label="企业微信二维码" required>
                  <div class="upload-container">
                    <el-input v-model="item.qrcode" placeholder="请输入企业微信二维码 URL，或点击上传" class="form-input" clearable />
                    <el-button type="success" @click="handleUploadQrcode(index)">
                      <el-icon>
                        <Upload />
                      </el-icon> 上传二维码
                    </el-button>
                  </div>
                  <div v-if="item.qrcode" class="qrcode-preview">
                    <img :src="item.qrcode" alt="企业微信二维码预览" class="preview-qrcode" />
                  </div>
                </el-form-item>
              </template>

              <el-divider v-if="index < copyrightForm.copyright_mini.length - 1" />
            </div>
          </div>

          <div class="add-btn-wrapper">
            <el-button type="primary" @click="addCopyright" class="add-copyright-btn">
              <el-icon>
                <Plus />
              </el-icon> 添加版权信息
            </el-button>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="dialogCopyrightVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCopyright" :loading="copyrightSubmitting">保存版权配置</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';
import config from '@/config.js';
import dayjs from 'dayjs';
import { auth } from '@/utils/auth.js';
import { beforeUpload, uploadToOSS, getUploadSignature } from '@/utils/uploadUtils';
import { Upload, Plus, Delete } from '@element-plus/icons-vue';

export default {
  name: 'MerchantManagement',
  components: { Upload, Plus, Delete },
  setup() {
    const searchForm = reactive({
      nickName: '',
      account: '',
      mobile: '',
    });

    const tableData = ref([]);
    const loading = ref(false);
    const pagination = reactive({
      currentPage: 1,
      pageSize: 15,
      total: 0,
    });

    const dialogVisible = ref(false);
    const isEdit = ref(false);
    const formRef = ref(null);
    const submitting = ref(false);

    const dialogRechargeVisible = ref(false);
    const rechargeFormRef = ref(null);
    const rechargeSubmitting = ref(false);
    const selectedUserId = ref(null);

    // 版权弹窗相关
    const dialogCopyrightVisible = ref(false);
    const copyrightSubmitting = ref(false);
    const currentMerchantId = ref(null);
    const copyrightForm = reactive({
      copyright_type: 'default',
      copyright_mini: []  // 永远不清空，保留用户配置的数据
    });

    const form = reactive({
      id: '',
      nickName: '',
      account: '',
      password: '',
      mobile: '',
      application_market: {
        "group_buy_mini_pro_sph_tg": true,
        "group_buy_mini_pro_video_ai": true,
        "group_buy_mini_pro_video_hj": true,
        "group_buy_mini_pro_video_jz": true
      },
      dianshu: '',
      out_date: '',
      is_disable: 0,
      aliyun_keyid: '',
      aliyun_secret: '',
      endpoint: '',
      aliyun_bucket: '',
      allow_parent_oss: 1,
      tencent_map_key: '',
      tencent_map_sk: '',
      allow_parent_map: 1,
      ai_draw_key: '',
      ai_allow_parent_draw: 1,
      ai_provider: 'deepseek',
      ai_api_url: '',
      ai_model: '',
      ai_api_key: '',
      ai_max_tokens: 2048,
      ai_temperature: 0.8,
      ai_allow_parent: 1
    });

    const rules = computed(() => ({
      nickName: [{ required: true, message: '请输入用户昵称', trigger: 'blur' }],
      account: [
        { required: true, message: '请输入用户账号', trigger: 'blur' },
        { min: 6, message: '账号至少6位', trigger: 'blur' }
      ],
      password: [
        { required: !isEdit.value, message: '请输入密码', trigger: 'blur' },
        { min: 6, message: '密码至少6位', trigger: 'blur' }
      ],
      mobile: [
        { required: true, message: '请输入用户电话', trigger: 'blur' },
        { pattern: /^\d{11}$/, message: '电话必须为11位数字', trigger: 'blur' }
      ],
      dianshu: [{ required: true, message: '请输入点数', trigger: 'blur' }],
      out_date: [{ required: true, message: '请选择过期时间', trigger: 'change' }],
      is_disable: [{ required: true, message: '请选择是否禁用', trigger: 'change' }],
    }));

    const rechargeForm = reactive({
      type: 'dianshu',
      amount: ''
    });

    const rechargeRules = {
      type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
      amount: [
        { required: true, message: '请输入数量', trigger: 'blur' },
        { type: 'number', message: '数量必须是数字', trigger: 'blur' }
      ],
    };

    const user = auth.getStoredUser();
    if (!user) {
      ElMessage.error('未检测到登录用户信息，请重新登录');
    }

    const handleQuery = () => {
      pagination.currentPage = 1;
      fetchData();
    };

    const handleReset = () => {
      searchForm.nickName = '';
      searchForm.account = '';
      searchForm.mobile = '';
      pagination.currentPage = 1;
      fetchData();
    };

    // AI服务商切换时自动填充默认接口地址和模型名称
    const onProviderChange = () => {
      const defaults = {
        deepseek: {
          url: 'https://api.deepseek.com/v1/chat/completions',
          model: 'deepseek-chat'
        },
        tongyi: {
          url: 'https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions',
          model: 'qwen-plus'
        },
        custom: {
          url: '',
          model: ''
        }
      };

      const selected = defaults[form.ai_provider];
      if (selected) {
        form.ai_api_url = selected.url;
        form.ai_model = selected.model;
      }
    };

    const fetchData = async () => {
      loading.value = true;
      try {
        const response = await axios.post(`${config.BASE_URL}/agent/api/merchant_api.php`, {
          action: 'query',
          username: user.username,
          nickName: searchForm.nickName,
          account: searchForm.account,
          mobile: searchForm.mobile,
          page: pagination.currentPage,
          pageSize: pagination.pageSize,
        });

        if (response.data.success) {
          tableData.value = response.data.data || [];
          pagination.total = response.data.total || 0;
        } else {
          ElMessage.error(response.data.message || '查询失败');
        }
      } catch (error) {
        console.error(error);
        ElMessage.error('查询失败，请检查网络或后端接口');
      } finally {
        loading.value = false;
      }
    };

    const handleSizeChange = (size) => {
      pagination.pageSize = size;
      fetchData();
    };

    const handleCurrentChange = (page) => {
      pagination.currentPage = page;
      fetchData();
    };

    const resetForm = () => {
      form.id = '';
      form.nickName = '';
      form.account = '';
      form.password = '';
      form.mobile = '';
      form.dianshu = '';
      form.out_date = '';
      form.is_disable = 0;
      form.aliyun_keyid = '';
      form.aliyun_secret = '';
      form.endpoint = '';
      form.aliyun_bucket = '';
      form.allow_parent_oss = 1;
      form.tencent_map_key = '';
      form.tencent_map_sk = '';
      form.allow_parent_map = 1;
      form.ai_draw_key = '';
      form.ai_allow_parent_draw = 1;
      form.ai_provider = 'deepseek';
      form.ai_api_url = '';
      form.ai_model = '';
      form.ai_api_key = '';
      form.ai_max_tokens = 2048;
      form.ai_temperature = 0.8;
      form.ai_allow_parent = 1;
    };

    const showAddModal = () => {
      isEdit.value = false;
      resetForm();
      dialogVisible.value = true;
    };

    const showEditModal = (row) => {
      isEdit.value = true;
      resetForm();
      Object.assign(form, {
        id: row.id,
        nickName: row.nickName || '',
        account: row.account || '',
        password: '',
        mobile: row.mobile || '',
        dianshu: row.dianshu ?? '',
        out_date: row.out_date || '',
        is_disable: row.is_disable !== undefined ? row.is_disable : 0,
        aliyun_keyid: row.aliyun_keyid || '',
        aliyun_secret: row.aliyun_secret || '',
        endpoint: row.endpoint || '',
        aliyun_bucket: row.aliyun_bucket || '',
        allow_parent_oss: row.allow_parent_oss !== undefined ? row.allow_parent_oss : 1,
        tencent_map_key: row.tencent_map_key || '',
        tencent_map_sk: row.tencent_map_sk || '',
        allow_parent_map: row.allow_parent_map !== undefined ? row.allow_parent_map : 1,
        ai_draw_key: row.ai_draw_key || '',
        ai_allow_parent_draw: row.ai_allow_parent_draw !== undefined ? row.ai_allow_parent_draw : 1,
        ai_provider: row.ai_provider || 'deepseek',
        ai_api_url: row.ai_api_url || '',
        ai_model: row.ai_model || '',
        ai_api_key: row.ai_api_key || '',
        ai_max_tokens: row.ai_max_tokens || 2048,
        ai_temperature: row.ai_temperature !== undefined ? row.ai_temperature : 0.8,
        ai_allow_parent: row.ai_allow_parent !== undefined ? row.ai_allow_parent : 1
      });
      dialogVisible.value = true;
    };

    const showRechargeModal = (row) => {
      selectedUserId.value = row.id;
      rechargeForm.type = 'dianshu';
      rechargeForm.amount = '';
      dialogRechargeVisible.value = true;
    };

    // ==================== 版权弹窗相关方法 ====================
    const showCopyrightModal = (row) => {
      currentMerchantId.value = row.id;
      copyrightForm.copyright_type = row.copyright_type || 'default';
      // 深拷贝商户的版权配置，不清空已有数据
      copyrightForm.copyright_mini = row.copyright_mini && Array.isArray(row.copyright_mini)
        ? JSON.parse(JSON.stringify(row.copyright_mini))
        : [];
      // 确保每条数据都有必要字段
      copyrightForm.copyright_mini.forEach(item => {
        if (!item.type) item.type = 'webpage';
        if (!item.value) item.value = '';
        if (!item.appid) item.appid = '';
        if (!item.path) item.path = '';
        if (!item.qrcode) item.qrcode = '';
      });
      dialogCopyrightVisible.value = true;
    };

    // 版权类型切换 - 不清空自定义版权数据
    const onCopyrightTypeChange = (val) => {
      // 只记录切换，不做任何清空操作
      // 这样用户从自定义切换到其他类型再切回来时，之前配置的数据还在
      console.log('版权类型切换为:', val);
    };

    const onItemTypeChange = (item) => {
      item.value = '';
      item.appid = '';
      item.path = '';
      item.qrcode = '';
    };

    const addCopyright = () => {
      copyrightForm.copyright_mini.push({
        icon: '',
        key: '',
        type: 'webpage',
        value: '',
        appid: '',
        path: '',
        qrcode: ''
      });
    };

    const removeCopyright = (index) => {
      copyrightForm.copyright_mini.splice(index, 1);
    };

    const handleUploadIcon = async (index) => {
      try {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.onchange = async (event) => {
          const file = event.target.files[0];
          if (!file) return;

          const isValid = await beforeUpload(file, {
            maxSize: 2,
            allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml'],
          });
          if (!isValid) return;

          const signatureData = await getUploadSignature('image');
          if (!signatureData) {
            ElMessage.error("获取上传签名失败");
            return;
          }

          const uploadResult = await uploadToOSS(file, signatureData);
          if (uploadResult.success) {
            ElMessage.success("图标上传成功");
            copyrightForm.copyright_mini[index].icon = uploadResult.url;
          } else {
            ElMessage.error("图标上传失败");
          }
        };
        fileInput.click();
      } catch (error) {
        console.error("上传图标失败:", error);
        ElMessage.error("上传图标失败，请重试");
      }
    };

    const handleUploadQrcode = async (index) => {
      try {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.onchange = async (event) => {
          const file = event.target.files[0];
          if (!file) return;

          const isValid = await beforeUpload(file, {
            maxSize: 2,
            allowedTypes: ['image/jpeg', 'image/png', 'image/gif'],
          });
          if (!isValid) return;

          const signatureData = await getUploadSignature('image');
          if (!signatureData) {
            ElMessage.error("获取上传签名失败");
            return;
          }

          const uploadResult = await uploadToOSS(file, signatureData);
          if (uploadResult.success) {
            ElMessage.success("二维码上传成功");
            copyrightForm.copyright_mini[index].qrcode = uploadResult.url;
          } else {
            ElMessage.error("二维码上传失败");
          }
        };
        fileInput.click();
      } catch (error) {
        console.error("上传二维码失败:", error);
        ElMessage.error("上传二维码失败，请重试");
      }
    };

    const submitCopyright = async () => {
      // 验证自定义版权数据（仅在当前选择的是自定义类型时才验证）
      if (copyrightForm.copyright_type === 'custom') {
        for (let i = 0; i < copyrightForm.copyright_mini.length; i++) {
          const item = copyrightForm.copyright_mini[i];
          if (!item.key || item.key.trim() === '') {
            ElMessage.warning(`第 ${i + 1} 条版权信息的名称不能为空`);
            return;
          }

          if (item.type === 'webpage' && (!item.value || item.value.trim() === '')) {
            ElMessage.warning(`第 ${i + 1} 条版权信息的链接地址不能为空`);
            return;
          }

          if (item.type === 'mini') {
            if (!item.appid || item.appid.trim() === '') {
              ElMessage.warning(`第 ${i + 1} 条版权信息的小程序AppID不能为空`);
              return;
            }
            if (!item.path || item.path.trim() === '') {
              ElMessage.warning(`第 ${i + 1} 条版权信息的小程序路径不能为空`);
              return;
            }
          }

          if (item.type === 'tel' && (!item.value || item.value.trim() === '')) {
            ElMessage.warning(`第 ${i + 1} 条版权信息的电话号码不能为空`);
            return;
          }

          if (item.type === 'wechat' && (!item.value || item.value.trim() === '')) {
            ElMessage.warning(`第 ${i + 1} 条版权信息的微信号不能为空`);
            return;
          }

          if (item.type === 'wecom' && (!item.qrcode || item.qrcode.trim() === '')) {
            ElMessage.warning(`第 ${i + 1} 条版权信息的企业微信二维码不能为空`);
            return;
          }
        }
      }

      copyrightSubmitting.value = true;
      try {
        const response = await axios.post(`${config.BASE_URL}/agent/api/merchant_api.php`, {
          action: 'update',
          username: user.username,
          id: currentMerchantId.value,
          copyright_type: copyrightForm.copyright_type,
          // 无论什么类型，都保存copyright_mini数据（后端只会在custom类型时使用）
          // 这样用户切回自定义时数据还在
          copyright_mini: copyrightForm.copyright_mini
        });

        if (response.data.success) {
          ElMessage.success('版权配置保存成功');
          dialogCopyrightVisible.value = false;
          fetchData();
        } else {
          ElMessage.error(response.data.message || '保存失败');
        }
      } catch (error) {
        console.error('保存版权配置失败:', error);
        ElMessage.error('保存失败，请检查网络连接');
      } finally {
        copyrightSubmitting.value = false;
      }
    };

    const submitForm = () => {
      formRef.value.validate(async (valid) => {
        if (valid) {
          submitting.value = true;
          let action = isEdit.value ? 'update' : 'add';
          let payload = { action, username: user.username, ...form };

          if (isEdit.value && !form.id) {
            ElMessage.error('缺少要编辑的ID');
            submitting.value = false;
            return;
          }

          if (!isEdit.value) {
            payload.application_market = JSON.stringify(form.application_market);
          }

          try {
            const response = await axios.post(`${config.BASE_URL}/agent/api/merchant_api.php`, payload);
            if (response.data.success) {
              ElMessage.success(isEdit.value ? '编辑成功' : '新增成功');
              dialogVisible.value = false;
              fetchData();
            } else {
              ElMessage.error(response.data.message || (isEdit.value ? '编辑失败' : '新增失败'));
            }
          } catch (error) {
            console.error(error);
            ElMessage.error(isEdit.value ? '编辑失败' : '新增失败');
          } finally {
            submitting.value = false;
          }
        }
      });
    };

    const submitRecharge = () => {
      rechargeFormRef.value.validate(async (valid) => {
        if (valid) {
          rechargeSubmitting.value = true;
          try {
            const response = await axios.post(`${config.BASE_URL}/agent/api/merchant_api.php`, {
              action: 'recharge',
              username: user.username,
              user_id: selectedUserId.value,
              type: rechargeForm.type,
              amount: Number(rechargeForm.amount)
            });

            if (response.data.success) {
              ElMessage.success('充值成功');
              dialogRechargeVisible.value = false;
              fetchData();
            } else {
              ElMessage.error(response.data.message || '充值失败');
            }
          } catch (error) {
            console.error(error);
            ElMessage.error('充值失败');
          } finally {
            rechargeSubmitting.value = false;
          }
        }
      });
    };

    const dateFormatter = (row, column, cellValue) => {
      if (!cellValue) return '';
      return dayjs(cellValue).format('YYYY-MM-DD');
    };

    const unixDateFormatter = (row, column, cellValue) => {
      if (!cellValue) return '';
      return dayjs.unix(cellValue).format('YYYY-MM-DD HH:mm:ss');
    };

    const isDisableFormatter = (row) => {
      return row.is_disable === 1 ? '禁用' : '正常';
    };

    onMounted(() => {
      fetchData();
    });

    return {
      searchForm,
      tableData,
      loading,
      pagination,
      dialogVisible,
      form,
      rules,
      formRef,
      isEdit,
      submitting,
      dialogRechargeVisible,
      rechargeForm,
      rechargeRules,
      rechargeFormRef,
      rechargeSubmitting,
      selectedUserId,
      dialogCopyrightVisible,
      copyrightSubmitting,
      copyrightForm,
      handleQuery,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      showAddModal,
      showEditModal,
      showRechargeModal,
      showCopyrightModal,
      onCopyrightTypeChange,
      onItemTypeChange,
      addCopyright,
      removeCopyright,
      handleUploadIcon,
      handleUploadQrcode,
      submitForm,
      submitRecharge,
      submitCopyright,
      isDisableFormatter,
      dateFormatter,
      onProviderChange,
      unixDateFormatter
    };
  },
};
</script>

<style scoped>
.merchant-management {
  padding: 1px;
}

.mb-4 {
  margin-bottom: 20px;
}

.toolbar {
  margin-bottom: 10px;
}

.pagination-wrap {
  margin-top: 10px;
  text-align: right;
}

.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  margin-left: 4px;
  line-height: 1.4;
}

/* 版权配置弹窗样式 */
.copyright-config-panel {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
}

.copyright-tip {
  margin-bottom: 20px;
}

.copyright-list {
  margin-bottom: 20px;
}

.copyright-item-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e8e8e8;
}

.copyright-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
}

.copyright-index {
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
}

.upload-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.upload-container .el-input {
  flex: 1;
  min-width: 200px;
}

.form-input {
  width: 100%;
}

.icon-preview,
.qrcode-preview {
  margin-top: 10px;
}

.preview-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 4px;
  background: #fff;
}

.preview-qrcode {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 4px;
  background: #fff;
}

.add-btn-wrapper {
  margin-bottom: 20px;
}

.add-copyright-btn {
  width: 100%;
}
</style>